import TextGradient from "@app/components/gradient/gradient-text";

const CompanyOutlookSectionBottomContent = () => {
  const sectionContents = [
    {
      title: "Fair, respectful, detailed.",
      underlineColorClass: "bg-secondary-light",
      content: `We promise to give you a fair value for your business, delivered with simplicity and confidentiality. 
      We provide ancillary opportunities to your customers with exceptional customer service. 
      We offer your employees benefits packages and options for continued growth.​`,
    },
    {
      title: "Selecting the right partner.",
      underlineColorClass: "bg-primary-light",
      content: `We provide excellent benefits for our acquisition partners. 
      These benefits include employee retention, the opportunity to retain your company name, national acquisition interest, creative deal structuring.​`,
    },
  ];

  return (
    <div className="flex flex-col-reverse lg:grid lg:grid-cols-12 2xl:w-2/3 overflow-hidden">
      <div className="lg:col-span-5 mt-16 lg:mt-0 flex justify-start">
        <div
          className="min-h-[600px] rounded-2xl h-full w-full bg-cover bg-right-top bg-no-repeat"
          style={{
            backgroundImage:
              "url('/images/acquisitions/company-outlook-02.png')",
          }}
        />
      </div>
      <div className="lg:col-span-7 flex flex-col items-center justify-center">
        <div className="flex flex-col items-start justify-center lg:p-16">
          <TextGradient overrideClassName="mb-4">
            <span className="label-lg">Our company traits</span>
          </TextGradient>
          <div className="flex flex-col space-y-10 lg:space-y-20">
            {sectionContents.map((content) => (
              <div key={content.title} className="flex flex-col space-y-5">
                <span className="mobile-h3 md:h5 lg:h3 text-base-dark">
                  {content.title}
                </span>
                <div
                  className={`h-2 w-[200px] ${content.underlineColorClass}`}
                />
                <span className="subheading text-text-color-mid-em">{content.content}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyOutlookSectionBottomContent;
